import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import useGetOrg from "src/hooks/useGetOrganization";
import { getAppRedirectsRequest } from "src/services/organizations/queries/redirects";
import { RedirectType } from "src/types/apps";

import Context from "../context";

export const useGetRedirects = () => {
	const { actions } = useContext(Context);

	const { id } = useGetOrg();
	const queryClient = useQueryClient();
	const { data: appId } = useQuery<string>({ queryKey: ["apps", "selected"], initialData: "" });
	const { data: redirects, isFetched } = useQuery<RedirectType[]>({
		queryKey: ["apps", "redirects", appId ?? ""],
		initialData: []
	});

	useEffect(() => {
		const fetchData = async () => {
			if (!isFetched && redirects.length === 0 && appId) {
				const fetchedRedirects: RedirectType[] = await getAppRedirectsRequest({ orgId: id, appId });
				queryClient.setQueryData(["apps", "redirects", appId], fetchedRedirects);
				if (fetchedRedirects.length) actions.setRedirect(fetchedRedirects[0]);
			} else {
				if (redirects.length) actions.setRedirect(redirects[0]);
			}
		};

		fetchData();
	}, [isFetched, appId, id]);

	return {
		data: redirects ?? []
	};
};
